<template>
  <div>
    <div class="row mt-3">
      <span class="simple-label col-12 col-md-4">{{$t('kiosks.name')}}:</span>
      <span class="col-12 col-md-8">{{kiosk.name}}</span>
    </div>
    <div class="row">
      <span class="simple-label col-12 col-md-4">{{$t('kiosks.serial')}}:</span>
      <span class="col-12 col-md-8">{{kiosk.serial}}</span>
    </div>
    <div class="row">
      <span class="simple-label col-12 col-md-4">{{$t('kiosks.facility')}}:</span>
      <span class="col-12 col-md-8">{{kiosk.facility ? kiosk.facility.name : 'N/A'}}</span>
    </div>
    <div class="row">
      <span class="simple-label col-12 col-md-4">{{$t('kiosks.type')}}:</span>
      <span class="col-12 col-md-8">{{kiosk.kiosk_type ? $t(kioskTypesAdapter[kiosk.kiosk_type]) : 'N/A'}}</span>
    </div>
    <div class="row">
      <span class="simple-label col-12 col-md-4">{{$t('kiosks.version')}}:</span>
      <span class="col-12 col-md-8">{{kiosk.version}}</span>
    </div>
    <div class="row">
      <span class="simple-label col-12 col-md-4">{{$t('kiosks.last_checkin')}}:</span>
      <span class="col-12 col-md-8">{{kiosk.checkin_at | localTime('YYYY-MM-DD HH:mm', '---') }}</span>
    </div>
    <div class="row">
      <span class="simple-label col-12 col-md-4">{{$t('kiosks.created_at')}}:</span>
      <span class="col-12 col-md-8">{{kiosk.created_at | localTime('YYYY-MM-DD', '---')}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    kiosk: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      kioskTypesAdapter: {
        1: 'kiosks.regular_kiosk',
        2: 'kiosks.portable_kiosk'
      },
    }
  }
}
</script>

<style scoped lang="scss">
.simple-label {
  font-weight: bold;
  font-size: 17px;
}

.custom-icon {
  cursor: pointer;
  color: #29c4a9;
  font-size: 1.2rem;
}
</style>
